exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navigation-list{list-style:none;margin:0;padding:0}.navigation-list li{display:-ms-flexbox;display:flex}.navigation-list li a{border-left:3px solid transparent;display:block;font-size:1.2rem;line-height:1.5;padding:5px;text-decoration:none}.navigation-list li a:hover{border-left-color:#ddd;color:#888}.navigation-list span{padding-top:5px}.navigation-list .favorite-active:after,.navigation-list .favorite-inactive:after{background-size:16px;margin:0;padding:0 13px 3px 8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/navigation-list/navigation-list.scss
// module id = 5272
// module chunks = 0